import Swal from "sweetalert2";

export class ConfirmBeforeDelete  {

    ConfirmBeforeDelete() {

    }

    constructor() {

    }

    confirm(url, title='') {
        Swal({
            title: "Delete Confirmation" + title,
            buttons: {
                cancel: "Cancel",
                confirm: {
                    className: "btnDeleteSwal",
                    value: 'delete',
                    text: "Delete",
                },
            },
        }).then((value) => {
                switch (value) {
                    case 'delete':
                        document.location.href = url;
                        break;
                }
            }
        );
    }
}

